<!-- Floating Cart Button -->
<div class="cart-float-button"
     [class.has-items]="!isEmpty()"
     (click)="toggleCart()">
  <div class="cart-icon">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
    @if (!isEmpty()) {
      <span class="cart-badge">{{ totalItems() }}</span>
    }
  </div>
  @if (!isEmpty()) {
    <div class="cart-total">
      {{ formatPrice(totalPrice()) }}
    </div>
  }
</div>

<!-- Cart Overlay -->
<div class="cart-overlay"
     [class.show]="showCart()"
     (click)="closeCart()">
</div>

<!-- Cart Panel -->
<div class="cart-panel"
     [class.show]="showCart()">

  <!-- Cart Header -->
  <div class="cart-header">
    <h3>🛒 Mi Pedido</h3>
    <button class="close-btn" (click)="closeCart()">✕</button>
  </div>

  <!-- Cart Content -->
  <div class="cart-content">

    @if (isEmpty()) {
      <!-- Empty Cart State -->
      <div class="empty-cart">
        <span class="empty-cart-icon">🛒</span>
        <h4>Tu carrito esta vacio</h4>
        <p>Anade algunos productos del menu para empezar tu pedido</p>
      </div>
    } @else {

      <!-- Restaurant Info -->
      @if (cart(); as currentCart) {
        <div class="restaurant-info">
          <h4>{{ currentCart.restaurant_name }}</h4>
          <small>Mesa: {{ currentCart.terminal_suffix }}</small>
        </div>
      }

      <!-- Cart Items -->
      <div class="cart-items">
        @for (item of cartItems(); track item.id) {
          <div class="cart-item">

            <!-- Item Image -->
            @if (item.image) {
              <div class="item-image">
                <img [src]="item.image" [alt]="item.name" />
              </div>
            }

            <!-- Item Details -->
            <div class="item-details">
              <h5>{{ item.name }}</h5>

              <!-- Customizations -->
              @if (item.customizations.length > 0) {
                <div class="customizations">
                  <small>{{ getCustomizationsText(item.customizations) }}</small>
                </div>
              }

              <!-- Notes -->
              @if (item.notes) {
                <div class="notes">
                  <small>📝 {{ item.notes }}</small>
                </div>
              }

              <!-- Price -->
              <div class="item-price">
                {{ formatPrice(item.price) }} x {{ item.quantity }}
              </div>
            </div>

            <!-- Item Controls -->
            <div class="item-controls">

              @if (isPackItem(item)) {
                <!-- Pack items: no +/-, only remove whole pack -->
                <div class="item-total">
                  @if (item.price > 0) {
                    {{ formatPrice(item.price) }}
                  }
                </div>
                <div class="item-actions">
                  <button class="action-btn remove"
                          (click)="removePackGroup(item)"
                          title="Eliminar pack completo">🗑️</button>
                </div>
              } @else {
                <!-- Normal items: quantity controls -->
                <div class="quantity-controls">
                  <button class="qty-btn"
                          [disabled]="item.quantity <= 1"
                          (click)="decreaseQuantity(item.id)">−</button>
                  <span class="quantity">{{ item.quantity }}</span>
                  <button class="qty-btn" (click)="increaseQuantity(item.id)">+</button>
                </div>

                <div class="item-total">
                  {{ formatPrice(getItemTotal(item)) }}
                </div>

                <div class="item-actions">
                  <button class="action-btn duplicate"
                          (click)="duplicateItem(item)"
                          title="Duplicar item">📋</button>
                  <button class="action-btn remove"
                          (click)="removeItem(item.id)"
                          title="Eliminar">🗑️</button>
                </div>
              }
            </div>
          </div>
        }
      </div>

      <!-- Cart Summary -->
      <div class="cart-summary">
        <div class="summary-row">
          <span>Total de articulos:</span>
          <span>{{ totalItems() }}</span>
        </div>
        <div class="summary-row total">
          <span><strong>Total:</strong></span>
          <span><strong>{{ formatPrice(totalPrice()) }}</strong></span>
        </div>
      </div>

      <!-- Cart Actions -->
      <div class="cart-actions">
        <button class="action-btn secondary" (click)="clearCart()">
          🗑️ Vaciar
        </button>
        <button class="action-btn continue" (click)="closeCart()">
          + Seguir Pidiendo
        </button>
        <button class="action-btn primary" (click)="proceedToCheckout()">
          💳 Realizar Pedido
        </button>
      </div>
    }
  </div>
</div>

<!-- Quick Customization Modal -->
<div class="customization-modal"
     [class.show]="editingItem() !== null">

  @if (editingItem(); as item) {
    <div class="modal-content">
      <div class="modal-header">
        <h4>Editar {{ item.name }}</h4>
        <button class="close-btn" (click)="cancelEditingItem()">✕</button>
      </div>

      <div class="modal-body">
        <!-- Quantity -->
        <div class="form-group">
          <label>Cantidad:</label>
          <div class="quantity-controls">
            <button class="qty-btn"
                    [disabled]="tempQuantity() <= 1"
                    (click)="tempQuantity.set(tempQuantity() - 1)">−</button>
            <input type="number"
                   [value]="tempQuantity()"
                   (input)="onQuantityInput($event)"
                   min="1" class="quantity-input" />
            <button class="qty-btn"
                    (click)="tempQuantity.set(tempQuantity() + 1)">+</button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="action-btn secondary" (click)="cancelEditingItem()">
          Cancelar
        </button>
        <button class="action-btn primary" (click)="saveEditedItem()">
          Guardar Cambios
        </button>
      </div>
    </div>
  }
</div>
